module.exports = __webpack_public_path__ + "img/22_41.2ab196d1.png";